export default __webpack_public_path__ + "static/media/21-FierySunset.aaf248f0.jpeg";